/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SecurityLabelDto
 */
export interface SecurityLabelDto {
    /**
     * 
     * @type {boolean}
     * @memberof SecurityLabelDto
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SecurityLabelDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SecurityLabelDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof SecurityLabelDto
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof SecurityLabelDto
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof SecurityLabelDto
     */
    securityLevel?: string;
    /**
     * 
     * @type {number}
     * @memberof SecurityLabelDto
     */
    securityLevelValue?: number;
    /**
     * 
     * @type {string}
     * @memberof SecurityLabelDto
     */
    color?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SecurityLabelDto
     */
    isActive?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SecurityLabelDto
     */
    tenantId?: string;
    /**
     * 
     * @type {Date}
     * @memberof SecurityLabelDto
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof SecurityLabelDto
     */
    updatedAt?: Date;
}

/**
 * Check if a given object implements the SecurityLabelDto interface.
 */
export function instanceOfSecurityLabelDto(value: object): value is SecurityLabelDto {
    return true;
}

export function SecurityLabelDtoFromJSON(json: any): SecurityLabelDto {
    return SecurityLabelDtoFromJSONTyped(json, false);
}

export function SecurityLabelDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SecurityLabelDto {
    if (json == null) {
        return json;
    }
    return {
        
        'active': json['active'] == null ? undefined : json['active'],
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'description': json['description'] == null ? undefined : json['description'],
        'securityLevel': json['securityLevel'] == null ? undefined : json['securityLevel'],
        'securityLevelValue': json['securityLevelValue'] == null ? undefined : json['securityLevelValue'],
        'color': json['color'] == null ? undefined : json['color'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
    };
}

export function SecurityLabelDtoToJSON(json: any): SecurityLabelDto {
    return SecurityLabelDtoToJSONTyped(json, false);
}

export function SecurityLabelDtoToJSONTyped(value?: SecurityLabelDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'active': value['active'],
        'id': value['id'],
        'name': value['name'],
        'displayName': value['displayName'],
        'description': value['description'],
        'securityLevel': value['securityLevel'],
        'securityLevelValue': value['securityLevelValue'],
        'color': value['color'],
        'isActive': value['isActive'],
        'tenantId': value['tenantId'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
    };
}

